//----------------------- IMPORT -------------------//
import Vue from 'vue';                      // Vue.js
import router from './router';              // Router
import App from './App';                    // App
import VueFirestore from 'vue-firestore';   // Firestore
import VueToasted from 'vue-toasted';       // TOASTED
import {store} from './store.js';           // STORE
import { saveAs } from 'file-saver';
import { RichTextEditorPlugin } from '@syncfusion/ej2-vue-richtexteditor';


import { BFormDatepicker, ModalPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'


//----------------------- JS -----------------------//
import jQuery from 'jquery';
import myDate from './assets/js/dateManager.js';    
import myPrice from './assets/js/priceManager.js';
import myCopier from './assets/js/copyManager.js';
import myInput from "./assets/js/inputManager.js";
import myPath from "./assets/js/pathManager.js";
import myFB from "./firebase-config.js";

import '../static/css/addon.css';

global.isDev = window.location.href.includes("http://localhost:80");
if (isDev){
	global.isTOK = window.localStorage.getItem('isTOK') === "true";
}
else{
	global.isTOK = window.location.href.includes("theother.kitchen");
}
if (!isTOK){
	jQuery('body').css('background-color','#ffffff');
	import('../static/css/css/mhd.css');
	document.title = "The Good Stuff";
}

//----------------------- VARS ---------------------//
Vue.config.productionTip = false;
Vue.use(VueFirestore);
Vue.use(VueToasted);
Vue.use(ModalPlugin)
Vue.use(RichTextEditorPlugin);
Vue.component('b-form-datepicker', BFormDatepicker)


global.$ = jQuery;
global.jQuery = jQuery;
global.myDate = myDate;
global.myPrice = myPrice;
global.myCopier = myCopier;
global.myFB = myFB;
global.myInput = myInput;
global.myPath = myPath;
global.projectName = "2020 Products Business";
global.customJS = require("./assets/js/custom.js").default;
global.copywriting = require("./multilingual.json");

global.copyCode = function(input){
	var dummy = document.createElement("textarea");
	document.body.appendChild(dummy);
	dummy.value = input;
	dummy.select();
	document.execCommand("copy");
	document.body.removeChild(dummy);
}

let app
myFB.auth.onAuthStateChanged(user => {
	new Vue({
		el: '#app',
		router,
		store,
		render: h=> h(App),
		data:{
			isDev: isDev,
			isTOK: isTOK
		}
	})
})




// WEBPACK FOOTER //
// ./src/main.js